import {useEffect, useState} from 'react';
import {getImageDatas} from '../ui/image';
import {TYPE_GABARIT} from '../utils/enums';

const useMediaImage = (images, gabarits = [TYPE_GABARIT.FORMAT_1X1]) => {
    const [mediaImage, setMediaImage] = useState('');

    useEffect(() => {
        const {src} = getImageDatas(images, gabarits) || {};
        setMediaImage(src);
    }, [gabarits, images]);

    return mediaImage;
};

export default useMediaImage;
